import { FC } from 'react';

import { SelectResponse } from '../../../../shared/model/commonModel';

interface DataGridArrayObjectsTemplateProps {
  value: SelectResponse[];
}

const DataGridArrayObjectsTemplate: FC<DataGridArrayObjectsTemplateProps> = (props) => {
  if (props.value) {
    const nestedObjects = (props.value as SelectResponse[]).map((nestedObject) => {
      return nestedObject.name;
    });

    return <>{nestedObjects.join(', ')}</>;
  }

  return <></>;
};

export default DataGridArrayObjectsTemplate;
